import React from 'react';
import { cn } from '../../lib/utils';
import { VerticalStack } from './Stack';

export interface PaneFooterProps {
  children: React.ReactNode;
  className?: string;
}

export function PaneFooter({ children, className }: PaneFooterProps) {
  return (
    <footer
      className={cn(
        'shrink-0 border-t border-border bg-background/80 p-6 backdrop-blur',
        className
      )}
    >
      <VerticalStack gap={3}>{children}</VerticalStack>
    </footer>
  );
}
